import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

export const StForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space6};

  @media ${breakpoints.m} {
    max-width: 600px;
  }
`
